<template>
  <div class="hiprint-printPagination">
    <el-menu>
      <el-menu-item index="1" @click="useTemplate">
        <i class="el-icon-menu"></i>
        <span class="muban" slot="title">恢复默认模板</span>
      </el-menu-item>
      <div class="tip">请将下列内容拖到右侧白色画布中</div>
      <el-submenu
        v-for="printElementType of printElementTypeGroup"
        :key="printElementType.name"
        :index="printElementType.name"
      >
        <template slot="title">
          <span class="muban">{{ printElementType.name }}</span>
        </template>
        <div class="drag-box">
          <div
            v-for="printElement in printElementType.elementType"
            :key="printElement.tid"
            :tid="printElement.tid"
            class="drag-item ep-draggable-item"
          >
            {{ printElement.title }}
          </div>
        </div>
      </el-submenu>
    </el-menu>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "PrintSetingAside",
  computed: {
    ...mapState(["printElementTypeGroup"]),
  },
  watch: {
    printElementTypeGroup: {
      handler() {
        if (this.printElementTypeGroup.length) {
          this.$nextTick(() => {
            this.$store.commit("changePrintStatus", 1);
          });
        }
      },
      deep: true,
    },
  },
  methods: {
    useTemplate() {
      this.$bus.$emit("useTemplate");
    },
  },
};
</script>

<style lang="less" scoped>
.muban {
  font-weight: 700;
  font-size: 15px;
}
.tip {
  padding: 10px 20px;
  color: #666;
  font-size: 13px;
}
.drag-box {
  display: flex;
  padding: 15px 15px;
  flex-wrap: wrap;
  .drag-item {
    min-width: 30%;
    max-width: 33%;
    background-color: #f3f6fd;
    margin: 2px;
    height: 30px;
    font-size: 14px;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
      "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji",
      "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    line-height: 30px;
    text-align: center;
    // 字体无法选择
    user-select: none;
    &:hover {
      background-color: #e5ebf4;
    }
  }
}
</style>